/** @deprecated - insurances functionality is moved to libs/my-zone/insurances */
export enum InsuranceControlDisplayCriteriaEnum {
    Always,
    StatusCode,
    ActiveCar,
    ActiveMotor,
    Family1ZON2ZON,
    Family1ZON1MET,
    Family1MET2ZON2MET,
    CarMotorMopedCaravan,
    CarMotorMoped,
    Date99991231,
    NoClaimYears,
}
